import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

/**
 * Fires a GA4 + PostHog page_view event on every SPA route change.
 * gtag's auto page_view only fires on hard loads — this covers client-side nav.
 */
export const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + location.search;
    track("page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
};
